import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MaterialModule } from '@angular/material';
import { DataTableModule, SharedModule } from 'primeng/primeng';

import { PendingHitsOverviewComponent } from './pending-hits-overview.component';
import { RelatedEntitiesTrackingDialogComponent } from './related-entities-tracking-dialog/related-entities-tracking-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MaterialModule.forRoot(),
    DataTableModule,
    SharedModule
  ],
  declarations: [
    PendingHitsOverviewComponent,
    RelatedEntitiesTrackingDialogComponent
  ],
  entryComponents: [
    RelatedEntitiesTrackingDialogComponent
  ],
  exports: [
    PendingHitsOverviewComponent
  ]
})
export class PendingHitsOverviewModule { }



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/pending-hits-overview/pending-hits-overview.module.ts